import ImportBadgerAccordion from './src/BadgerAccordion'
import ImportBadgerAccordionItem from './src/BadgerAccordionItem'

export const BadgerAccordion = ImportBadgerAccordion;
export const BadgerAccordionItem = ImportBadgerAccordionItem;
